import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import "react-tooltip/dist/react-tooltip.css";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
